import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { sendBusinessEvent } from '@/screens/Checkout/monitoring';

const NotFound = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Send screen viewed business event
    sendBusinessEvent('kitopay.screen.viewed', {
      screen: 'not_found',
    });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'not_found', {
        page_path: '/404',
      });
    }
  }, []);

  return (
    <div data-testid="not-found">
      <h1>{t('notfound.notFound.code404')}</h1>
    </div>
  );
};

export default NotFound;
